<div class="card" [ngStyle]="{ 'width': width, height: height }">
  @if (title && title.length > 0) {
    <div class="card-header">
      <h3 class="card-title">{{ title }}</h3>
    </div>
  }
  @if (subtitle && subtitle.length > 0) {
    <div class="card-header">
      <h3 class="card-title">{{ subtitle }}</h3>
    </div>
  }
  <div class="card-content">
    <ng-content></ng-content>
  </div>
  <div class="card-actions">
    <ng-content select="[card-actions]"></ng-content>
  </div>


